<mat-toolbar>
  <nav mat-tab-nav-bar [tabPanel]="tabPanel">
    <button
      mat-tab-link
      *ngFor="let module of modules"
      [q9Track]="module?.q9Track!"
      [active]="currentModule() === module.route"
      (click)="navigateTo(module)">
      {{ module.title | translate }}
    </button>
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>

  <mat-divider [vertical]="true"></mat-divider>

  <div class="actions">
    <ng-content></ng-content>
  </div>
</mat-toolbar>
